import axios from 'axios'
import store from '@/state/store'

let _axiosBackendApi1 = null;
let _axiosBackendApi2 = null;
let _axiosBackendApi3 = null;
let _axiosAuthBackendApi3 = null;
let _axiosBackendMubinApi = null;

export function initAxiosBackend(config = {}) {
    _axiosBackendApi1 = axios.create({
        baseURL: config.baseURLApi1,
        headers: {
            'accept': 'application/json',
        }
    })

    _axiosBackendApi2 = axios.create({
        baseURL: config.baseURLApi2,
        headers: {
            'accept': 'application/json',
        }
    })

    _axiosBackendApi3 = axios.create({
        baseURL: config.baseURLApi3,
        headers: {
            'accept': 'application/json',
        }
    })

    _axiosBackendMubinApi = axios.create({
        baseURL: config.baseURLMubinApi,
        headers: {
            'accept': 'application/json',
        }
    })
    
    _axiosAuthBackendApi3 = _axiosBackendApi3

}

export function  getAxiosBackendApi1() {
    return _axiosBackendApi1
}

export function  getAxiosBackendApi2() {
    return _axiosBackendApi2
}

export function  getAxiosBackendApi3() {
    return _axiosBackendApi3
}

export function  getAxiosBackendMubinApi() {
    return _axiosBackendMubinApi
}

export function  getAuthAxiosBackendApi3() {
    _axiosAuthBackendApi3.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters['authPilgrimage/getToken']
    return _axiosAuthBackendApi3
}